module.exports = __webpack_public_path__ + "static/media/Inter-Black.14a450a3.woff";